import { cx } from 'linaria';
import * as React from 'react';
import * as styles from './alert.styles';

export type ActionVariant = 'text' | 'button';

export interface AlertActionsProps {
    variant?: ActionVariant;
}

export const AlertActions = React.forwardRef<HTMLDivElement, React.PropsWithChildren<AlertActionsProps>>(
    (props, ref) => {
        const { variant, children } = props;
        return (
            <div className={cx(styles.actionBar, variant === 'button' && styles.actionBarButton)} ref={ref}>
                {children}
            </div>
        );
    },
);
AlertActions.displayName = 'AlertActions';
